/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StateTown
 */
export interface StateTown {
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    city_ascii?: string;
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    city_alternative?: string;
    /**
     * 
     * @type {string}
     * @memberof StateTown
     */
    county_name?: string;
}

/**
 * Check if a given object implements the StateTown interface.
 */
export function instanceOfStateTown(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StateTownFromJSON(json: any): StateTown {
    return StateTownFromJSONTyped(json, false);
}

export function StateTownFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateTown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'city_ascii': !exists(json, 'city_ascii') ? undefined : json['city_ascii'],
        'city_alternative': !exists(json, 'city_alternative') ? undefined : json['city_alternative'],
        'county_name': !exists(json, 'county_name') ? undefined : json['county_name'],
    };
}

export function StateTownToJSON(value?: StateTown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state_id': value.state_id,
        'city': value.city,
        'city_ascii': value.city_ascii,
        'city_alternative': value.city_alternative,
        'county_name': value.county_name,
    };
}

